import { render, staticRenderFns } from "./DailyMenuSection.vue?vue&type=template&id=94dd2298&scoped=true"
import script from "./DailyMenuSection.vue?vue&type=script&lang=js"
export * from "./DailyMenuSection.vue?vue&type=script&lang=js"
import style0 from "./DailyMenuSection.vue?vue&type=style&index=0&id=94dd2298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd2298",
  null
  
)

export default component.exports